import { render, staticRenderFns } from "./coupon-item.vue?vue&type=template&id=16301394&scoped=true&"
import script from "./coupon-item.vue?vue&type=script&lang=js&"
export * from "./coupon-item.vue?vue&type=script&lang=js&"
import style0 from "./coupon-item.vue?vue&type=style&index=0&id=16301394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16301394",
  null
  
)

export default component.exports